function editGuestDialog () {
  return {
    restrict: 'E',
    templateUrl: '/admin/dialogs/edit-guest/edit-guest-dialog.html?$$REVISION$$'
  }
}

export { editGuestDialog }
